import { useContext } from 'react';
import { message } from 'antd';
import { updateDashboardTitle } from '@store/tempDashboard/actions';
import { FormActionContext } from '../context';
import { trackQueryError } from '@src/utils/sensor/apptracker';
import { updateAlert } from '@src/api/manualAlerts';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';

const useUpdateAlert = (setSaving, alert) => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();
  const {
    actions: { onCancel },
  } = useContext(FormActionContext);
  const mutation = useMutation(
    (payload) => {
      return updateAlert(payload);
    },
    {
      onSuccess: (response) => {
        const { name } = response.data;
        onCancel();
        dispatch(updateDashboardTitle(`Alert: ${alert.name}`, `Alert: ${name}`));
        setSaving(false);
        queryClient.invalidateQueries(['manual-alert', 'list']);
        message.success(`Alert "${name}" updated successfully`);
      },
      onError: (err) => {
        trackQueryError({ type: 'manual-alert-update', err });
      },
    },
  );

  return mutation;
};

export default useUpdateAlert;
